module.exports = __webpack_public_path__ + "static/media/contentPic1.6ab5b2c2.png";